<template>
<transition @leave="leave">
  <a-entity>
    <a-entity  position="0 0 -1">
      <a-circle
        class="TitleLevel"
        :class="'is-' + index"
        ref="circle"
        color="#fc1f1f"
        look-at=".Camera"
        radius=".33"
        segments="64"
        transparent="true"
        material="shader: flat; depthTest: false"
        scale="0 0 0"
        position="0 0 -1"
        @materialtextureloaded="circleReady"
      >
        <a-image
          :src="cdn(require('./img/' + index + '-' + lang + '.png'))"
          height=".66"
          width=".66"
          shader="flat"
          ref="text"
          opacity="0"
          material="shader: flat; depthTest: false"
          position="0 0 .001"
          @materialtextureloaded="enter"
        />
      </a-circle>

      <a-entity @loaded="setDyniquePos('play_pause')" ref="play_pause" v-if="vr || $root.$agent.mobile">
        <PlayPause size=".2" />
      </a-entity>
      <a-entity @loaded="setDyniquePos('skip')" ref="skip" v-if="vr || $root.$agent.mobile">
        <Skip size=".2" />
      </a-entity>

    </a-entity>
  </a-entity>
</transition>
</template>

<script>
import Skip from '@/components/skip/Skip'
import PlayPause from '@/components/play_pause/PlayPause'

export default {
  name: 'TextLevel',
  props: ['index'],
  components: { PlayPause, Skip },
  data: () => ({
    checkPos: [
      {
        ref: 'circle',
        desktop: { scale: 2.1 },
        mobile: { scale: 1.3 },
        // vr: { scale: 2.1 },
      },
      {
        ref: 'play_pause',
        desktop: { x: .85, y: .12, z: -1 },
        mobile: { x: .8, y: .12, z: -2 },
        // vr: { x: 1.2, y: .12, z: -2 },
      },
      {
        ref: 'skip',
        desktop: { x: .85, y: -.12, z: -1 },
        mobile: { x: .8, y: -.12, z: -2 },
        // vr: { x: 1.2, y: -.12, z: -2 },
      }
    ]
  }),
  methods: {
    circleReady() {
      const routeName = this.$route.meta.name
      const color = routeName == 'level' || routeName == 'captation' ? this.levels[this.index] : this.levels['intro-3']
      const material = this.$refs.circle.object3DMap.mesh.material
      material.color = new THREE.Color(color)
      material.blending = THREE.MultiplyBlending
    },
    enter() {
      this.setDyniquePos()

      const tl = new TimelineLite()
      .to({}, 4, {})
      .set(this.$el, { aframe: { rotationY: () => THREE.Math.radToDeg(this.$parent.$refs.camera.object3D.rotation.y) }})
      .from(this.$refs.circle, 1, { aframe: { scale: 0 }})
      .to(this.$refs.text, 1, { aframe: { alpha: 1 }})

      if(this.$refs.skip && this.$refs.play_pause)
        tl.from([this.$refs.skip, this.$refs.play_pause], 1, { aframe: { scale: 0 }})
    },
    leave(el, done) {
      const tl = new TimelineLite({ onComplete: done })
      .to(this.$refs.text, 1, { aframe: { alpha: 1 }})
      .to(this.$refs.circle, 1, { aframe: { scale: 0 } })

      if(this.$refs.skip && this.$refs.play_pause)
        TweenLite.to([this.$refs.skip, this.$refs.play_pause], 1, { aframe: { scale: 0 }})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/title-level/TitleLevel.vue